"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");

var polished_1 = require("polished");

var prop_types_1 = tslib_1.__importDefault(require("prop-types"));

var react_1 = tslib_1.__importDefault(require("react"));

var sportnet_utilities_1 = require("sportnet-utilities");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var ContentContext_1 = tslib_1.__importDefault(require("../../../common/ContentContext"));

var utilities_2 = require("../../utilities");

var section_1 = tslib_1.__importDefault(require("./section"));

var linkClass = 'widget-sectionlist-link';
var linkClassActive = 'widget-sectionlist-link-active';
var Wrapper = styled_components_1["default"]('div')(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin: ", ";\n"], ["\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return polished_1.rem(-theme.grid.gutterWidth / 2);
});
var SectionWrapper = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  & > div {\n    margin: ", ";\n  }\n  min-width: 100%;\n  ", " {\n    min-width: 50%;\n  }\n  ", " {\n    min-width: 33.33%;\n  }\n  ", " {\n    min-width: 25%;\n  }\n"], ["\n  & > div {\n    margin: ", ";\n  }\n  min-width: 100%;\n  ", " {\n    min-width: 50%;\n  }\n  ", " {\n    min-width: 33.33%;\n  }\n  ", " {\n    min-width: 25%;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return polished_1.rem(theme.grid.gutterWidth / 2);
}, utilities_1.mb('xs'), utilities_1.mb('m'), utilities_1.mb('l'));
var WrapperTab = styled_components_1["default"]('div')(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  border-bottom: ", " solid #7e7e7f;\n  width: 100%;\n  padding: 0;\n  font-size: ", ";\n  > :first-child {\n    margin-left: 0px;\n  }\n  ", " {\n    padding: 0 ", " 0 ", ";\n  }\n\n  .", " {\n    display: block;\n    padding: ", " ", " ", " ", ";\n    border: ", " solid #7e7e7f;\n    margin-bottom: ", ";\n    background: #f5f5f5;\n    font-weight: 100;\n    color: ", ";\n    cursor: pointer;\n    font-family: 'Ubuntu', sans-serif;\n    text-align: center;\n    text-decoration: none;\n    ", " {\n      display: inline-block;\n      border-top-left-radius: ", ";\n      border-top-right-radius: ", ";\n      margin-left: ", ";\n    }\n  }\n\n  .", " {\n    background: #fff;\n    margin-bottom: none;\n    color: #000;\n    ", " {\n      border-bottom: ", " solid #fff;\n    }\n  }\n"], ["\n  border-bottom: ", " solid #7e7e7f;\n  width: 100%;\n  padding: 0;\n  font-size: ", ";\n  > :first-child {\n    margin-left: 0px;\n  }\n  ", " {\n    padding: 0 ", " 0 ", ";\n  }\n\n  .", " {\n    display: block;\n    padding: ", " ", " ", " ", ";\n    border: ", " solid #7e7e7f;\n    margin-bottom: ", ";\n    background: #f5f5f5;\n    font-weight: 100;\n    color: ", ";\n    cursor: pointer;\n    font-family: 'Ubuntu', sans-serif;\n    text-align: center;\n    text-decoration: none;\n    ", " {\n      display: inline-block;\n      border-top-left-radius: ", ";\n      border-top-right-radius: ", ";\n      margin-left: ", ";\n    }\n  }\n\n  .", " {\n    background: #fff;\n    margin-bottom: none;\n    color: #000;\n    ", " {\n      border-bottom: ", " solid #fff;\n    }\n  }\n"])), polished_1.rem(1), polished_1.rem(14), utilities_1.mb('s'), polished_1.rem(16), polished_1.rem(16), linkClass, polished_1.rem(10), polished_1.rem(20), polished_1.rem(9), polished_1.rem(20), polished_1.rem(1), polished_1.rem(-1), function (_a) {
  var theme = _a.theme;
  return theme.color.base;
}, utilities_1.mb('s'), polished_1.rem(5.3), polished_1.rem(5.3), polished_1.rem(-1), linkClassActive, utilities_1.mb('s'), polished_1.rem(1));

function WidgetSectionList(props) {
  var renderLink = props.renderLink,
      renderEmpty = props.renderEmpty;
  var _a = props.data,
      _b = _a.hideSectionTitles,
      hideSectionTitles = _b === void 0 ? false : _b,
      displayAsTabs = _a.displayAsTabs;
  var sections = sportnet_utilities_1.getProp(props, ['data', 'data', 'sectionFilter', 'sections'], []);
  var _c = react_1["default"].useContext(ContentContext_1["default"]).currentSectionId,
      currentSectionId = _c === void 0 ? null : _c;

  if (!sections.length && renderEmpty) {
    return renderEmpty(props.data.type);
  }

  return react_1["default"].createElement(react_1["default"].Fragment, null, displayAsTabs ? react_1["default"].createElement(WrapperTab, null, sections.map(function (section) {
    var isActive = currentSectionId === section._id;
    return react_1["default"].createElement(react_1["default"].Fragment, {
      key: section._id
    }, renderLink({
      type: utilities_2.WIDGET_LINK_TYPE.SECTION_DETAIL,
      payload: section,
      section: section,
      linkProps: {
        className: linkClass + " " + (isActive && linkClassActive),
        children: section.name
      }
    }));
  })) : react_1["default"].createElement(Wrapper, null, sections.map(function (section) {
    return react_1["default"].createElement(SectionWrapper, {
      key: section._id
    }, react_1["default"].createElement(section_1["default"], {
      renderLink: renderLink,
      section: section,
      hideSectionTitles: hideSectionTitles
    }));
  })));
}

WidgetSectionList.propTypes = {
  data: prop_types_1["default"].shape({
    data: prop_types_1["default"].shape({
      sectionFilter: prop_types_1["default"].shape({
        sections: prop_types_1["default"].array.isRequired
      }).isRequired
    }).isRequired,
    hideSectionTitles: prop_types_1["default"].bool,
    displayAsTabs: prop_types_1["default"].bool,
    sectionFilter: prop_types_1["default"].array
  }).isRequired,
  renderLink: prop_types_1["default"].func.isRequired,
  renderEmpty: prop_types_1["default"].func
};
exports["default"] = WidgetSectionList;
var templateObject_1, templateObject_2, templateObject_3;